import { useState, useEffect } from "react";

export function useDebounce(value, delay = 500) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    // limpiar timeout si value cambia antes de que termine el delay
    return () => clearTimeout(handler);
  }, [value, delay]);

  return debouncedValue;
}
